import React from 'react';
import Category from './Category';

const NoteEditor = ({ addNewNote, activeNote, onUpdateNote, onDeleteNote, setFavoriteNote, setCompleteNote, cat_filters, updateNoteCategories }) => {

    const onEditField = (key, value) => {
        onUpdateNote({
            ...activeNote,
            [key]: value,
        })
    };

    if (!activeNote) return (
        <div className='app-note-edit'>
            <div className="empty-note-editor">
                <i className="empty-note-editor__icon material-icons">notes</i>
                <div className="empty-note-editor__message">No note selected!
                </div>
            </div>
            <span className="icon-button note__add size-xl material-icons" onClick={addNewNote}>add</span>
        </div>
    )
    return (
        <div className='app-note-edit'>
            <div className="note-editor">
                <div className="note-editor__header">
                    <input type="text"
                        className="note-editor__title"
                        placeholder="Set the note title"
                        value={activeNote.title}
                        onChange={(e) => onEditField('title', e.target.value)}>
                    </input>
                    <span className={`icon-button note__completed-toggle size-l  material-icons${activeNote.completed === true ? ' completed' : ''}`}
                        onClick={() => setCompleteNote(activeNote.id)}
                    >check</span>
                    <span className={`icon-button note__starred-toggle size-l material-icons${activeNote.favorite === true ? ' starred' : ''}`}
                        onClick={() => setFavoriteNote(activeNote.id)}>{activeNote.favorite === true ? 'star' : 'star_outline'}</span>
                    <span className="icon-button note__delete size-l material-icons" onClick={() => onDeleteNote(activeNote.id)}>delete_outline</span>
                </div>
                <div className="categories-selector">
                    {cat_filters.map((category) => (
                        <Category
                            key={category.id}
                            category={category}
                            activeNote={activeNote}
                            updateNoteCategories={updateNoteCategories}
                        />
                    ))}
                </div>
                <textarea className="note-editor__content"
                    placeholder="Set the note content"
                    value={activeNote.content}
                    onChange={(e) => onEditField('content', e.target.value)}>
                </textarea>
            </div>
            <span className="icon-button note__add size-xl material-icons" onClick={addNewNote}>add</span>
        </div>
    );
}

export default NoteEditor;